var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-category",style:({
    backgroundColor: _vm.category.color,
  })},[_c('span',{staticClass:"product-category__name"},[_vm._v(_vm._s(_vm.$t(`productCategory.${_vm.category.name}`)))]),(_vm.category.icon)?_c('span',{staticClass:"product-category__icon"},[_c('i',{class:`icon-${_vm.category.icon}`})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }